export default __webpack_public_path__ + "static/harvard-logo-e74b81bd006d8964199c067f45ba94cb.svg";